
import axios from 'axios'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../../Routes/Routes1'
import './profile.css'


export default function Profile(){
    const USER_STORAGE=JSON.parse(localStorage.getItem("sangeetUser"))
    const [editProfile,setEditProfile]=useState(false)
    const {state}=useContext(UserContext)
    const [currName,setName]=useState(USER_STORAGE.name)
    const navigator=useNavigate()
    
    if(!state){
        navigator('/login')
    }
    
    function nameChange(e){
        setName(e.target.value)
    }
    
    function editData(){
        setEditProfile(true)
    }  
    function submitEditData(){
        USER_STORAGE.name=currName
        localStorage["sangeetUser"]=JSON.stringify(USER_STORAGE)
        const newData=JSON.parse(localStorage.getItem("sangeetUser"))
        const PORT=process.env.REACT_APP_URL_PORT
        axios.post(`https://${PORT}/admin/update_user`,newData)
        .then(()=>{
                setEditProfile(false)
                window.location.reload()
            }
            
        )
    } 
    return(
        <div className="row">
            <div className="col-12 mt-5">
            {state?
                editProfile?
                <div className="row container mt-5">
                    <div className="col-12">
                        Name: <input type='text' value={currName} onChange={(e)=>nameChange(e)}/>
                    </div>
                    <div className="col-12 mt-2">
                        E-mail: <input type='email' value={USER_STORAGE.email} readOnly/>
                    </div>
                    <div className="col-12 mt-3">
                        <button type='button' className='btn btn-secondary btn-sm' onClick={submitEditData}>Submit</button>
                    </div>
                </div>:
                <div className="row container mt-5">
                    <div className="col-12">
                        Name: {USER_STORAGE.name}
                    </div>
                    <div className="col-12 mt-1">
                        E-mail: {USER_STORAGE.email}
                    </div>
                    <div className="col-12 mt-3">
                        <button type='button' className='btn btn-secondary btn-sm'  onClick={editData}>Edit Profile</button>
                    </div>
                </div>:<div className='mt-5'>Loading...</div>

            }
                
            </div>
        </div>
    )
}

